module.exports = __webpack_public_path__ + "img/xingbake.f1dc2824.png";